/* eslint-disable */
// Action Types
const FETCH_WORKERS = "FETCH_WORKERS";
const ADD_WORKER = "ADD_WORKER";
const UPDATE_WORKER = "UPDATE_WORKER";
const DELETE_WORKER = "DELETE_WORKER";
const SET_LOADING = "SET_LOADING";
const SET_ERROR = "SET_ERROR";

// Initial State - FIXED STRUCTURE
const workersInitialState = {
  workers: [],
  loading: false,
  error: null,
};

// Action Creators
export const fetchWorkers = (payload) => ({
  type: FETCH_WORKERS,
  payload,
});

export const addWorker = (payload) => ({
  type: ADD_WORKER,
  payload,
});

export const updateWorker = (payload) => ({
  type: UPDATE_WORKER,
  payload,
});

export const deleteWorker = (payload) => ({
  type: DELETE_WORKER,
  payload,
});

export const setLoading = (payload) => ({
  type: SET_LOADING,
  payload,
});

export const setError = (payload) => ({
  type: SET_ERROR,
  payload,
});

// Reducer - FIXED to handle nested state
const workersReducer = (state = workersInitialState, action) => {
  switch (action.type) {
    case FETCH_WORKERS:
      return {
        ...state,
        workers: action.payload,
        loading: false,
        error: null,
      };

    case ADD_WORKER:
      return {
        ...state,
        workers: [...state.workers, action.payload],
        loading: false,
        error: null,
      };

    case UPDATE_WORKER:
      return {
        ...state,
        workers: state.workers.map((worker) =>
          worker.id === action.payload.id
            ? { ...worker, ...action.payload }
            : worker
        ),
        loading: false,
        error: null,
      };

    case DELETE_WORKER:
      return {
        ...state,
        workers: state.workers.filter((worker) => worker.id !== action.payload),
        loading: false,
        error: null,
      };

    case SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case SET_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    default:
      return state;
  }
};

export default workersReducer;
